import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { getSessionId } from "../../../utils/tokenHandlers";
import { getTaxIssuedBy } from "../../../feature/apis/listOfValues/getTaxIssuedBy";

interface CountryDropdownProps {
  name: string;
  label: string;
  register: any;
  required?: boolean;
  requiredMessage?: string;
  handleChange?: () => JSX.Element;
  defaultValue?: string;
  error?: string;
}

interface TaxIssuedBy {
  sr_no: number;
  lov_type: string;
  lov_display_value: string;
  lov_value: string;
  is_active: boolean;
}

const TaxIssuedBy: React.FC<CountryDropdownProps> = ({
  name,
  label,
  register,
  required,
  requiredMessage = "This field is required",
  handleChange,
  defaultValue,
  error,
}) => {
  const token = getSessionId();

  const [taxIssuedValues, setTaxIssuedValues] = useState<TaxIssuedBy[]>([]);

  useEffect(() => {
    getTaxIssuedBy(token).then((response) => {
      //// console.log("COUNTRY API --> ", response);
      setTaxIssuedValues(response.result.result);
    });
  }, []);

  return (
    <Form.Group as={Col} className="mb-3">
      <Row className="align-items-center">
        <Form.Label column md={4}>
          <span className="float-end">
            {label}&nbsp;
            <span className="text-danger form-label">
              {required ? "*" : ""}
            </span>
            :
          </span>
        </Form.Label>
        <Col md={8}>
          <Form.Select
            as="select"
            className={`custom-input form-control ${error ? "is-invalid" : ""}`}
            onChange={handleChange}
            {...register(name, {
              required: required ? requiredMessage : false,
            })}
            defaultValue={defaultValue}
          >
            <option value="">Select Option</option>
            {taxIssuedValues.map((taxIssuedValue, index) => (
              <option key={index} value={taxIssuedValue.lov_value}>
                {taxIssuedValue.lov_display_value}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col md={4}></Col>
        <Col md={8}>{error && <p className="m-0 err-msg">{error}</p>}</Col>
      </Row>
    </Form.Group>
  );
};

export default TaxIssuedBy;
